import { render, staticRenderFns } from "./Data_Table.vue?vue&type=template&id=10fef7ba&"
import script from "./Data_Table.vue?vue&type=script&lang=js&"
export * from "./Data_Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports